<ng-container [ngSwitch]="loginState">
  <app-login
    *ngSwitchCase="templateLoginStateEnum.login"
    (loginEmitter)="login($event)"
    (trezorLoginEmitter)="loginTrezor()"
    [waiting]="waiting"
  ></app-login>
  <app-loading *ngSwitchCase="templateLoginStateEnum.twoFactorTrezor"></app-loading>
  <ng-container *ngSwitchDefault>
    <app-login-2fa
      *ngIf="loginState !== templateLoginStateEnum.login && loginState !== templateLoginStateEnum.twoFactorTrezor"
      [email]="loginEmail"
      (twoFactorCodeEmitter)="twoFactorCodeEntered($event)"
      [type]="loginState"
      [waiting]="waiting"
      #twoFaLoginComponent
    >
    </app-login-2fa>
  </ng-container>
</ng-container>
